import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { ThemeProvider } from "@/lib/theme";
import { GlobalShortcuts } from "@/lib/GlobalShortcuts";
import { ScrollToHash } from "@/lib/ScrollToHash";
import { AppShell } from "@/components/layout/AppShell";
import Paper from "@/pages/Paper";
import Components from "@/pages/Components";
import { PresentationView } from "@/components/presentation/PresentationView";

/**
 * Two route trees:
 *   /present  \u2192 immersive Presentation Mode (hidden from primary nav)
 *   /*        \u2192 the Growth Partner Brief — a single-page strategy paper
 *
 * The paper is one route. Every "section" is an anchor on `/`.
 */
function PaperRoutes() {
  return (
    <AppShell>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Paper />} />
        <Route path="/components" element={<Components />} />
        <Route path="*" element={<Paper />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <BrowserRouter>
        <GlobalShortcuts />
        <Routes>
          <Route path="/present" element={<PresentationView />} />
          <Route path="/*" element={<PaperRoutes />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
